/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import LZString from 'lz-string';
import Map from "./Map";
import NavPageSelector from "../../components/NavPageSelector";
import SignInComponent from "../../components/Sign/SignComponent";
import CoordinatesInput from "../../components/CoordinatesInput";
import { useState } from "react";
import "./style.css";
import MonitoringDialog from "./MonitoringDialog";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { resetStore } from "../../reducers/resetStore";
import {useMediaQuery, useTheme} from "@mui/material";
import Stripe from "../BasePage/Stripe";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";


const Index = () => {
  const dispatch = useDispatch();
  const retrievedCompressed = localStorage.getItem('mapFileContent');
    const mapFile = retrievedCompressed ? LZString.decompress(retrievedCompressed) : null;
  //   side modal
  const [open, setOpen] = useState(false);
  const areas = useSelector((state) => state.mapState.areas);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    dispatch(resetStore());
    setOpen(false);
  };

  return (
    <div className="monitoring-container">
      <div className="map-wrapper">
      {!isMobile && <Stripe>
          <NavPageSelector route={"masking"} />
          <div className="stripe-content">
            <LanguageSwitcher stripe={true}/>
            <SignInComponent
              menuIconColor="black"
              backgroundColor="white"
              classN="modalcontainer-base"
              stripe={true}
            />
          </div>
        </Stripe> }
        <Stripe second={true}>
          <CoordinatesInput disableFileUpload={false} />
          <button
            className="submit-compare-buttons"
            onClick={() => {
              if (!areas || !areas[0] || !areas[0].coordinates) {
                toast.error(
                  "Please select the area you want to be monitored"
                );
              } else {
                handleOpen();
              }
            }}
          >
            {t('Map.monitoring')}
          </button>
        </Stripe>
        
        {isMobile && <NavPageSelector route={"masking"} /> }

        <Map mapFile={mapFile} />

        {/* side modal */}
        <div className="submit-compare-buttons-container">
          
          <MonitoringDialog mainIndex={"all"} open={open} handleClose={handleClose} />
        </div>
      </div>
    </div>
  );
};

export default Index;
